import { z } from "zod";

/**
 * Zod schema for validating discount code usage limits.
 *
 * @property {boolean} limited - Indicates if the discount code is constrained by the set limits.
 * @property {number} limit - Specifies the maximum number of times the discount code can be used if it is limited. Must be a non-negative number.
 * @property {boolean} oneUsePerCustomer - When true, the discount code can only be used once per customer.
 */
const discountCodeUsageLimitZodObject = z.object({
    /** True when discount code is constrained by the set limits */
    limited: z.boolean(),
    /** If limited than limit is how many times it can be used */
    limit: z.number().min(0),
    /** When true code only be used by a single customer once */
    oneUsePerCustomer: z.boolean(),
});

type DiscountCodeUsageLimit = z.infer<typeof discountCodeUsageLimitZodObject>;

export { discountCodeUsageLimitZodObject };
export type { DiscountCodeUsageLimit };
